var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEventColorIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.83 8.65716L14.3239 12.2438L15.1519 17.3095C15.1879 17.531 15.1012 17.7548 14.9278 17.8872C14.83 17.9622 14.7134 18 14.5969 18C14.5074 18 14.4173 17.9776 14.3352 17.932L10 15.5404L5.66539 17.9315C5.47627 18.0366 5.24606 18.0195 5.07269 17.8866C4.89933 17.7543 4.81266 17.5304 4.84867 17.3089L5.67665 12.2432L2.17001 8.65716C2.01691 8.50003 1.96119 8.26494 2.02761 8.05171C2.09402 7.83847 2.2702 7.68194 2.4824 7.64945L7.32809 6.9111L9.49511 2.30258C9.6848 1.89914 10.3152 1.89914 10.5049 2.30258L12.6719 6.9111L17.5176 7.64945C17.7298 7.68194 17.906 7.83787 17.9724 8.05171C18.0388 8.26553 17.9831 8.49944 17.83 8.65716Z",
    fill: "url(#paint0_linear_12761_22644)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_12761_22644",
    x1: 2,
    y1: 3.06666,
    x2: 18,
    y2: 20.4,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7906A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#A12E98"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8D85"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEventColorIcon);
export default __webpack_public_path__ + "static/media/event-color-icon.38dd04ef06216f70323058e280ecf1a1.svg";
export { ForwardRef as ReactComponent };